import React, { useState, useEffect } from "react";
import Layout from "../../components/layout/Layout";
import logo from "../../assets/images/logo.svg";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { APIURL } from "../../redux/action/config";
import dateFormat from "dateformat";
import { connect, useDispatch, useSelector } from "react-redux";
import { fleetList } from "../../redux/action/fleet";
import { staffList } from "../../redux/action/staff";
import { getOrderById } from "../../redux/action/order";
import loader from "../../components/loader/loader";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { downloadProofOfServicePdf } from "../../utils/proofOfServicePdf";
const ViewOrder = ({ listOrders }) => {
  const [viewDetails, setViewDetails] = useState();
  const [loading, setLoading] = useState(true);
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    const token = localStorage.getItem("token");

    var config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    };
    axios
      .get(`${APIURL}/api/v1/order/${id}`, config)
      .then((response) => {
        setViewDetails(response.data);
      })
      .catch((error) => console.log("error", error));
    dispatch(fleetList());
    dispatch(staffList());
    setLoading(true);
    Promise.resolve(dispatch(getOrderById(id))).finally(() =>
      setLoading(false)
    );
  }, [id]);

  const FleetData = useSelector((state) => state.fleet.list);
  const StaffData = useSelector((state) => state.staff.list);
  const viewList = listOrders?.data?.order ? listOrders?.data?.order : "";

  // const AllFleets = FleetData?.data?.fleet?.filter(
  //   (item) => item.status == "active"
  // );
  // const ALLStaffs = StaffData?.filter((item) => item.status == "active");

  const assignedStaff =
    StaffData && StaffData?.filter((item) => viewList?.staff_id == item?._id);
  // viewList?.staff_id == item?._id
  const assignedFleet = FleetData?.data?.fleet?.filter(
    (item) => viewList?.fleet_id?._id == item?._id,
  );
  const recentOrderStatus = (status) => {
    switch (status) {
      case "order_initiated":
        return "Order Initiated";
      case "order_placed":
        return "Order Placed";
      case "order_in_progress":
        return "Order In Progress";
      case "order_completed":
        return "Order Completed";
      case "order_canceled":
        return "Order Canceled";
      default:
    }
  };
  const recentOrderColor = (status) => {
    switch (status) {
      case "order_initiated":
        return "badge-light-dark";
      case "order_placed":
        return "badge-light-info";
      case "order_in_progress":
        return "badge-light-warning";
      case "order_completed":
        return "badge-light-success";
      case "order_canceled":
        return "badge-light-danger";
      default:
    }
  };
  // "n/a",
  //         "staff_assigned",
  //         "reached_at_location",
  //         "setting_safety_items",
  //         "access_situation",
  //         "rectifiying_problem",
  //         "towing_required",
  //         "task_completed",
  const taskStatus = (status) => {
    switch (status) {
      case "n/a":
        return "Staff will assigned soon";
      case "staff_assigned":
        return "Staff assigned";
      case "reached_at_location":
        return "Staff reached at location";
      case "setting_safety_items":
        return "Setting safety items";
      case "access_situation":
        return "Access situation";
      case "rectifiying_problem":
        return "Rectifiying problem";
      case "towing_required":
        return "Towing required";
      case "task_completed":
        return "Task completed";
      default:
    }
  };
  const taskStatusColor = (status) => {
    switch (status) {
      case "n/a":
        return "badge-light-dark";
      case "staff_assigned":
        return "badge-light-info";
      case "reached_at_location":
        return "badge-light-dark";
      case "setting_safety_items":
        return "badge-light-info";
      case "access_situation":
        return "badge-light-warning";
      case "rectifiying_problem":
        return "badge-light-info";
      case "towing_required":
        return "badge-light-danger";
      case "task_completed":
        return "badge-light-success";
      default:
    }
  };

  // Prefer this order's own charge; the customer's membership charge is
  // only a fallback for orders that were covered by a membership.
  const paymentDetails =
    viewList?.transaction?.[0]?.[0]?.paymentCharge ||
    viewDetails?.data?.order?.customer_id?.purched_memberships?.[0]
      ?.transition?.[0];

  const downloadPDF = async () => {
    const capture = document.querySelector(".pdfview");

    // Use higher scale for better quality
    html2canvas(capture, { scale: 5 }).then((canvas) => {
      const imgData = canvas.toDataURL("image/png", 1.0); // Use 1.0 for the highest quality

      const doc = new jsPDF("p", "mm", "a4");
      const pageWidth = doc.internal.pageSize.getWidth(); // Get the page width
      const pageHeight = doc.internal.pageSize.getHeight(); // Get the page height

      const imgWidth = 200; // Adjust this based on your needs
      const imgHeight = (imgWidth * canvas.height) / canvas.width; // Maintain aspect ratio

      // Calculate x and y positions to center the image horizontally and vertically
      const xPos = (pageWidth - imgWidth) / 2;
      const yPos = 2;

      // Add the high-quality image to the PDF
      doc.addImage(
        imgData,
        "PNG",
        xPos,
        yPos,
        imgWidth,
        imgHeight,
        undefined,
        "FAST",
      ); // FAST for HD rendering
      doc.save(`${viewList?.invoice_no}-roadsideresponse.pdf`);
    });
  };
  // pdf code end
  const printPage = () => {
    const originalTitle = document.title;
    document.title = viewList?.invoice_no
      ? `#${viewList.invoice_no}`
      : `#${id}`;
    window.print();
    document.title = originalTitle;
  };

  return (
    <React.Fragment>
      <Layout title="View Service Requests" page="viewServiceRequest">
        <div id="kt_content_container row" className="container-fluid">
          <div className="d-flex justify-content-between">
            <div></div>
            <div className="ms-3">
              <a
                className="btn pgf btn-secondary dropdown-toggle"
                href="#"
                // role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                // className="csvlink"
                style={{ background: "none" }}
              >
                Download File
              </a>

              <ul className="dropdown-menu">
                <li>
                  <a className="dropdown-item"
                    style={{ cursor: "pointer" }} onClick={downloadPDF}>
                    Download as PDF
                  </a>
                </li>
                <li>
                  <a className="dropdown-item"
                    style={{ cursor: "pointer" }} onClick={printPage}>
                    Print
                  </a>
                </li>
                <li>
                  <a
                    className="dropdown-item"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      downloadProofOfServicePdf(viewList, {
                        staff: assignedStaff?.[0],
                        fleet: assignedFleet?.[0],
                      })
                    }
                  >
                    Download Proof of Service
                  </a>
                </li>
              </ul>
            </div>
          </div>
          {!loading ? (
            <div className="row pdfview">
              <div className="col-xl-8 mb-5">
                <div className="card">
                  <div className="card-body p-lg-20">
                    <div className="d-flex flex-column flex-xl-row">
                      <div className="flex-lg-row-fluid me-xl-18 mb-10 mb-xl-0">
                        <div className="mt-n1">
                          <div className="d-flex flex-stack pb-10">
                            <Link to="#">
                              <img alt="Logo" src={logo} />
                            </Link>
                            <div className="mb-8">
                              <span
                                className={`badge ${recentOrderColor(
                                  viewList?.status,
                                )} me-2`}
                              >
                                {recentOrderStatus(viewList?.status)}
                              </span>
                            </div>
                          </div>
                          {viewList?.emergencyMessage ? (
                            <div className="mb-8 emergency-data">
                              <div className="mb-1 fw-bolder fs-6 text-gray-800">
                                Emergency Message:
                              </div>
                              <span className={`badge badge-light-danger me-2`}>
                                {viewList?.emergencyMessage}
                              </span>
                            </div>
                          ) : (
                            ""
                          )}
                          <div className="m-0">
                            <div className="fw-bolder fs-3 text-gray-800 mb-2">
                              {/* Invoice #{viewList?.invoice_no} */}
                              Order number #{viewList?.invoice_no}
                            </div>
                            <div className="mb-8 d-flex align-items-center justify-content-between gap-4">
                              <div className="order-date-time-label fw-bolder fs-6 text-gray-800">
                                Date & Time:{" "}
                                <span className="fw-normal">
                                  {" "}
                                  {viewList?.createdAt
                                    ? dateFormat(
                                        viewList?.createdAt,
                                        "mm/dd/yyyy HH:mm:ss",
                                      )
                                    : "N/A"}
                                </span>
                              </div>
                              {/* <div className="order-date-time-value">
                                {viewList?.createdAt
                                  ? dateFormat(
                                      viewList?.createdAt,
                                      "mm/dd/yyyy HH:mm:ss",
                                    )
                                  : "N/A"}
                              </div> */}
                            </div>
                            <div className="row g-5 mb-10">
                              <div className="col-sm-6">
                                <div className="fw-bolder fs-6 text-gray-800">
                                  Request by:
                                </div>
                                <div className="fw-bold fs-7 text-gray-600">
                                  {`${
                                    viewList?.customer_id?.firstName
                                      ? viewList?.customer_id?.firstName
                                      : ""
                                  } ${
                                    viewList?.customer_id?.lastName
                                      ? viewList?.customer_id?.lastName
                                      : ""
                                  }`}
                                </div>
                              </div>
                              {/* <div className="col-sm-6">
                                <div className="fw-bolder fs-6 text-gray-800">
                                  Issued By:
                                </div>
                                <div className="fw-bold fs-7 text-gray-600">
                                  Roadside
                                </div>
                              </div> */}
                            </div>
                            {viewList?.cancel_reason && (
                              <div className="flex-grow-1 mb-6">
                                <span className="fw-bolder fs-6 text-gray-800">
                                  Cancel Reason :{" "}
                                </span>
                                <span className="badge badge-light-danger ms-2">
                                  {viewList?.cancel_reason}
                                </span>
                              </div>
                            )}
                            <div className="flex-grow-1">
                              <div className="table-responsive border-bottom mb-9">
                                <table className="table mb-3">
                                  <thead>
                                    <tr className="border-bottom fs-6 fw-bolder text-muted">
                                      <th className="min-w-175px pb-2">
                                        Description
                                      </th>
                                      <th className="min-w-70px text-end pb-2">
                                        Quantity
                                      </th>
                                      <th className="min-w-80px text-end pb-2">
                                        Price
                                      </th>
                                      <th className="min-w-100px text-end pb-2">
                                        Amount
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr className="fw-bolder text-gray-700 fs-5 text-end">
                                      <td className="">{viewList?.details}</td>
                                      <td className="pt-6 text-end">
                                        {viewList?.details ? 1 : ""}
                                      </td>
                                      <td className="pt-6 text-end">
                                        {viewList?.total_amount == undefined ||
                                        viewList?.total_amount == ""
                                          ? ""
                                          : `$${viewList?.total_amount}`}
                                      </td>
                                      <td className="pt-6 text-end text-dark fw-boldest">
                                        {viewList?.total_amount == undefined ||
                                        viewList?.total_amount == ""
                                          ? ""
                                          : `$${viewList?.total_amount}`}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div className="table-responsive border-bottom mb-9">
                                <table className="table mb-3">
                                  <thead>
                                    <tr className="border-bottom fs-6 fw-bolder text-muted">
                                      <th className="min-w-175px pb-2">
                                        Service Name
                                      </th>
                                      <th className="min-w-70px text-end pb-2">
                                        Service Price
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {console.log(viewList, "viewList=====>")}
                                    <tr className="fw-bolder text-gray-700 fs-5 text-end">
                                      <td className="d-flex align-items-center pt-6 text-end">
                                        {viewList?.service_id?.name
                                          ? viewList?.service_id?.name
                                          : "N/A"}
                                      </td>
                                      <td className="pt-6 text-end">
                                        {viewList?.service_id?.price
                                          ? `$${viewList?.service_id?.price}`
                                          : viewList?.transaction?.[0]?.[0]
                                                ?.amount
                                            ? `$${viewList?.transaction?.[0]?.[0]?.amount}`
                                            : "N/A"}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                              <div className="d-flex justify-content-end">
                                <div className="mw-300px">
                                  <div className="d-flex flex-stack mb-3">
                                    <div className="fw-bold pe-10 text-gray-600 fs-7">
                                      Total:
                                    </div>
                                    <div className="text-end fw-bolder fs-6 text-gray-800">
                                      {viewList?.total_amount == undefined ||
                                      viewList?.total_amount == ""
                                        ? ""
                                        : `$${viewList?.total_amount}`}
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                            {viewList?.notes?.[0]?.length > 0 && (
                              <div className="mb-8">
                                <div className="notes-outer">
                                  <span className="fw-bolder fs-6 text-gray-800 mb-1">
                                    Notes:
                                  </span>

                                  <div className="notes-list mt-3">
                                    <ul className="">
                                      {viewList?.notes?.[0]?.length > 0 &&
                                        viewList?.notes?.[0]?.map(
                                          (val, ind) => {
                                            return (
                                              <li
                                                className="list-group-item notes-item"
                                                key={ind}
                                              >
                                                <p className="fs-7 text-gray-600 float-right mb-2 d-flex justify-content-between">
                                                  <span>Commented at</span>
                                                  <span>
                                                    {val?.createdAt
                                                      ? dateFormat(
                                                          val?.createdAt,
                                                          "dddd, dd/mm/yyyy, h:MM TT",
                                                        )
                                                      : ""}
                                                  </span>
                                                </p>
                                                <p className="fs-6 fw-bold mb-2 d-flex">
                                                  <span
                                                    style={{ color: "#ff4e00" }}
                                                    className="me-2"
                                                  >
                                                    *
                                                  </span>
                                                  {val?.note}
                                                </p>
                                              </li>
                                            );
                                          },
                                        )}
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="m-0 col-xl-4 completed-tasks">
                <div className="mb-4">
                  <div className="border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten">
                    <div className="mb-8">
                      <span
                        className={`badge ${taskStatusColor(
                          viewList?.task_status,
                        )} me-2`}
                      >
                        {taskStatus(viewList?.task_status)}
                      </span>
                    </div>
                    <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                      PAYMENT DETAILS
                    </h6>
                    <div className="mb-6">
                      <div className="fw-bolder text-gray-800 fs-6">Stripe</div>
                      <div className="fw-bold text-gray-600 fs-7">
                        {` Card Type : ${
                          paymentDetails?.payment_method_details?.card?.brand
                            ? paymentDetails?.payment_method_details?.card
                                ?.brand
                            : viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details?.card?.brand
                              : "N/A"
                        }`}
                      </div>
                      <div className="fw-bold text-gray-600 fs-7">
                        {` Country : ${
                          paymentDetails?.payment_method_details?.card?.country
                            ? paymentDetails?.payment_method_details?.card
                                ?.country
                            : viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details?.card?.country
                              : "N/A"
                        }`}
                      </div>
                      <div className="fw-bold text-gray-600 fs-7">
                        {` Card Details : **** **** **** ${
                          paymentDetails?.payment_method_details?.card?.last4
                            ? paymentDetails?.payment_method_details?.card
                                ?.last4
                            : viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details?.card?.last4
                              : "N/A"
                        }`}
                      </div>
                      <div className="fw-bold text-gray-600 fs-7">
                        {` Card expiration time : ${
                          paymentDetails?.payment_method_details?.card
                            ?.exp_month
                            ? paymentDetails?.payment_method_details?.card
                                ?.exp_month
                            : viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details?.card?.exp_month
                              : "N/A"
                        }/${
                          paymentDetails?.payment_method_details?.card?.exp_year
                            ? paymentDetails?.payment_method_details?.card
                                ?.exp_year
                            : viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details?.card?.exp_year
                              : "N/A"
                        }`}
                      </div>
                      <div className="fw-bold text-gray-600 fs-7">
                        {` Customer Email : ${
                          paymentDetails?.receipt_email
                            ? paymentDetails?.receipt_email
                            : viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.payment_method_details
                              ? viewList?.transaction?.[0]?.[0]?.paymentCharge
                                  ?.receipt_email
                              : "N/A"
                        }`}
                      </div>
                    </div>
                    {/* <div className="mb-6">
                      <div className="fw-bold text-gray-600 fs-7">
                        Payment Term:
                      </div>
                      <div className="fw-bolder fs-6 text-gray-800 d-flex align-items-center">
                        14 days
                        <span className="fs-7 text-danger d-flex align-items-center">
                          <span className="bullet bullet-dot bg-danger mx-2"></span>
                          Due in 7 days
                        </span>
                      </div>
                    </div> */}
                  </div>
                </div>
                <div className="mt-5 mb-5">
                  <div className="border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten ">
                    <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                      ASSIGNED STAFF
                    </h6>
                    <div className="row mb-5">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Staff</span>
                        </label>
                        <div className="fw-bold text-gray-600 fs-7">
                          {assignedStaff?.[0]?.firstName
                            ? `${
                                assignedStaff?.[0]?.firstName
                                  ? assignedStaff?.[0]?.firstName
                                  : ""
                              } ${
                                assignedStaff?.[0]?.lastName
                                  ? assignedStaff?.[0]?.lastName
                                  : ""
                              }`
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mt-5 mb-5">
                  <div className="border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten ">
                    <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                      ASSIGNED FLEET
                    </h6>
                    <div className="row mb-5">
                      <div className="col-md-12 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Fleet</span>
                        </label>
                        <div className="fw-bold text-gray-600 fs-7">
                          {assignedFleet?.[0]?.name
                            ? `${assignedFleet?.[0]?.name}(${assignedFleet?.[0]?.registration_no})`
                            : "N/A"}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="m-0 row details">
                <div className="m-0 col-xl-4">
                  <div className="border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten mb-5">
                    <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                      CUSTOMER DETAILS
                    </h6>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>User Name</span>
                        </label>
                        <div className="fw-bold text-gray-600 fs-7">
                          {`${
                            viewList?.customer_id?.firstName
                              ? viewList?.customer_id?.firstName
                              : ""
                          } ${
                            viewList?.customer_id?.lastName
                              ? viewList?.customer_id?.lastName
                              : ""
                          }`}
                        </div>
                      </div>
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Phone Number </span>
                        </label>
                        <div className="fw-bold text-gray-600 fs-7">
                          {viewList?.customer_id?.phone}
                        </div>
                      </div>
                    </div>
                    <div className="row mb-5">
                      <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>Date</span>
                        </label>
                        <div className="fw-bold text-gray-600 fs-7">
                          {dateFormat(
                            viewList?.customer_id?.createdAt,
                            "d mmmm , yyyy",
                          )}
                        </div>
                      </div>
                      {/* <div className="col-md-6 fv-row fv-plugins-icon-container">
                        <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                          <span>status</span>
                        </label>
                        <div className="fw-bold text-gray-600 fs-7">
                          {viewList?.customer_id?.status}
                        </div>
                      </div> */}
                    </div>
                    <div className="col-md-12 fv-row fv-plugins-icon-container">
                      <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                        <span>Email Address</span>
                      </label>
                      <div className="fw-bold text-gray-600 fs-7">
                        {viewList?.customer_id?.email}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="m-0 col-xl-4">
                  <div className="m-0 mb-5">
                    <div className="border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten ">
                      <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                        SERVICE DETAILS
                      </h6>
                      <div className="row mb-5">
                        <div className="col-md-12 fv-row fv-plugins-icon-container">
                          <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                            <span>Name</span>
                          </label>
                          <div className="fw-bold text-gray-600 fs-7">
                            {viewList?.service_id?.name}
                          </div>
                        </div>
                      </div>
                      <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                        VEHICLE DETAILS
                      </h6>
                      {viewList?.vehicle_id?.[0]?.name ? (
                        <div className="row mb-5">
                          <div className="col-md-12 fv-row fv-plugins-icon-container">
                            <div className="row mb-5">
                              <div className="col-md-6 fv-row fv-plugins-icon-container">
                                <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                  <span>Registration No.</span>
                                </label>
                                <div className="fw-bold text-gray-600 fs-7">
                                  {viewList?.vehicle_id?.[0]?.reg_no}
                                </div>
                              </div>
                              <div className="col-md-6 fv-row fv-plugins-icon-container">
                                <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                  <span>Name</span>
                                </label>
                                <div className="fw-bold text-gray-600 fs-7">
                                  {viewList?.vehicle_id?.[0]?.name}
                                </div>
                              </div>
                            </div>
                            <div className="row mb-5">
                              <div className="col-md-6 fv-row fv-plugins-icon-container">
                                <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                  <span>Color</span>
                                </label>
                                <div className="fw-bold text-gray-600 fs-7">
                                  {viewList?.vehicle_id?.[0]?.color}
                                </div>
                              </div>
                              <div className="col-md-6 fv-row fv-plugins-icon-container">
                                <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                  <span>Model</span>
                                </label>
                                <div className="fw-bold text-gray-600 fs-7">
                                  {viewList?.vehicle_id?.[0]?.model}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
                <div className="m-0 col-xl-4">
                  <div className="m-0">
                    <div className="border border-dashed border-gray-300 card-rounded min-w-md-350px p-9 bg-lighten">
                      <h6 className="mb-8 fw-boldest text-gray-600 text-hover-primary">
                        ADDRESS DETAILS
                      </h6>
                      {viewList?.address_id?.[0]?.address ? (
                        <div className="row mb-5">
                          <div className="col-md-12 fv-row fv-plugins-icon-container">
                            <div className="row mb-5">
                              <div className="col-md-6 fv-row fv-plugins-icon-container">
                                <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                  <span>Address</span>
                                </label>
                                <div className="fw-bold text-gray-600 fs-7">
                                  {viewList?.address_id?.[0]?.address}
                                </div>
                              </div>
                              {viewList?.address_id?.[0]?.city && (
                                <div className="col-md-6 fv-row fv-plugins-icon-container">
                                  <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                    <span>City</span>
                                  </label>
                                  <div className="fw-bold text-gray-600 fs-7">
                                    {viewList?.address_id?.[0]?.city}
                                  </div>
                                </div>
                              )}
                            </div>
                            <div className="row mb-5">
                              {viewList?.address_id?.[0]?.state && (
                                <div className="col-md-6 fv-row fv-plugins-icon-container">
                                  <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                    <span>State</span>
                                  </label>
                                  <div className="fw-bold text-gray-600 fs-7">
                                    {viewList?.address_id?.[0]?.state}
                                  </div>
                                </div>
                              )}
                              {viewList?.address_id?.[0]?.street_no && (
                                <div className="col-md-6 fv-row fv-plugins-icon-container">
                                  <label className="d-flex align-items-center fs-6 fw-bold mb-4">
                                    <span>Street No</span>
                                  </label>
                                  <div className="fw-bold text-gray-600 fs-7">
                                    {viewList?.address_id?.[0]?.street_no}
                                  </div>
                                </div>
                              )}
                              {viewList?.address_id?.[0]?.street_no && (
                                <div className="col-md-6 fv-row fv-plugins-icon-container">
                                  <label className="d-flex align-items-center fs-6 fw-bold mb-4">
                                    <span>Street No</span>
                                  </label>
                                  <div className="fw-bold text-gray-600 fs-7">
                                    {viewList?.address_id?.[0]?.street_no}
                                  </div>
                                </div>
                              )}
                              {viewList?.address_id?.[0]?.zip && (
                                <div className="col-md-6 fv-row fv-plugins-icon-container">
                                  <label className="d-flex align-items-center fs-6 fw-bold mb-2">
                                    <span>Zip</span>
                                  </label>
                                  <div className="fw-bold text-gray-600 fs-7">
                                    {viewList?.address_id?.[0]?.zip}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : (
            loader()
          )}
        </div>
      </Layout>
    </React.Fragment>
  );
};

// export default ViewOrder;
const mapStateToProps = (state) => ({
  listOrders: state?.order?.view_order,
});

export default connect(mapStateToProps, { getOrderById })(ViewOrder);
